module.exports = __webpack_public_path__ + "static/hubnorte_logo-11b73beaf4d03863e074cafa4c967bb3.png";